import { GET_MONTHLY, GET_SIZE_MONTHLY } from '../actions/monthly.action'
import dayjs from 'dayjs'

const initState = {
  date: dayjs(new Date()).format('MMMM YYYY'),
  size: 0
}

const monthlyReducer = (state = initState, action) => {
  switch (action.type) {
    case GET_MONTHLY:
      return {
        ...state,
        date: action.payload.date
      }

    case GET_SIZE_MONTHLY:
      return {
        ...state,
        size: action.payload.size
      }
    default:
      return state
  }
}

export default monthlyReducer
